<template>
    <div>
        <template v-if="parentScreen === 'force-news'">
            <h5>
                <span>
                    {{titleLabel}}
                </span>
                <label class="require-block" v-if="requireCharacters">*</label>
                <slot name="tooltip"></slot>
            </h5>
            <hr class="sub-title"/>
            <div class="section-inner">
                <div class="group">
                    <div class="form-group">
                        <div class="col-sm-12">
                            <slot></slot>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template v-if="parentScreen === 'edit-profile'">
            <div class="form-group-sub">
                <h4 class="title">
                  {{titleLabel}}
                  <slot name="tooltip"></slot>
                </h4>
                <slot></slot>
            </div>
        </template>
    </div>
</template>

<script>
    /**
     * @author HungNS
     */
    export default {
        name: "ForceNewsBlockWrapper",
        props: {
            titleLabel: {
                type: String,
                required: true
            },
            requireCharacters: {
                required: false,
                default:false
            },
            parentScreen: {
                type: String,
                required: false,
                default: 'force-news'
            },
        }
    }
</script>

<style scoped>

</style>